import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class GlobalLoaderService {
    private standardMessage = 'Operazione in corso, attendi...';
    private _isLoading = new BehaviorSubject<boolean>(false);
    private _message = new BehaviorSubject<string>(this.standardMessage);

    constructor() {}

    get message$() {
        return this._message.asObservable();
    }
    get isLoading$() {
        return this._isLoading.asObservable();
    }

    hide() {
        this._message.next(this.standardMessage);
        this._isLoading.next(false);
    }

    show(message: string = null) {
        if (message) {
            this._message.next(message);
        }
        this._isLoading.next(true);
    }
}
